/**
 * Apis Monitoring Url Formatter.
 */
window.apisMonitoringUrlFormatter = function(value, row) {
    let html = '';
    if (row.url) {
        html += '<a href="'+row.url+'" target="_index">';
        html += '<i class="fal fa-external-link"></i>';
        html += '</a>';
    }
    return html;
};
